<template>
  <div v-if='totals!==0' class='pagination-container' style="width: 100%;overflow: auto;padding-right: 10px;" :style="{textAlign: textAlign}">
    <el-pagination
      :current-page.sync='queryInfo.current'
      :page-size.sync='queryInfo.size'
      :layout='layout'
      :page-sizes='pageSizes'
      :total='totals'
      v-bind='$attrs'
      @size-change='handleSizeChange'
      @current-change='handleCurrentChange'
    />
  </div>

  <!--v-if='this.totals!==0'-->
</template>

<script>

export default {
  name: 'Pagination',
  data() {
    return {
      totals: 0,
      queryInfo: {},
      params: {},
      data: {},
      //页面是否初始访问
      init: true
    }
  },
  props: {
    page: {
      type: Number,
      default: 1
    },
    total: Number,
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 40, 50, 100]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    query: Object,
    //查询参数
    queryParam: Object,
    //查询数据
    queryData: Object,
    textAlign: {
      type: String,
      default: 'center'
    }
  },
  watch: {
    //兼容老的传输模式
    total(val) {
      this.totals = val
    }
  },
  created() {
    if (this.query) {
      this.queryInfo = JSON.parse(JSON.stringify(this.query))
      this.selectList(1)
    } else {
      this.queryInfo = JSON.parse(JSON.stringify({
        current: this.page,
        size: this.limit
      }))
    }
  },
  methods: {
    //执行初始查询
    run() {
      //读取查询状态
      const state = history.state
      if (state && state.query && this.init) {
        //更新查询条件
        this.$emit('update:queryParam', state.query)
        //更新查询条件
        this.$emit('update:queryData', state.data)
        this.selectList(state.query.current, state.query.size, state.query, state.data)
      } else {
        this.selectList(this.queryInfo || 1, this.queryInfo.size || 20, this.queryParam, this.queryData)
      }
    },
    selectList(current, size, params, data) {
      if (current && current > 0) {
        this.queryInfo.current = current
      }
      if (size && size > 0) {
        this.queryInfo.size = size
      }
      if (params) {
        this.params = params
      }
      if (data) {
        this.data = data
      }
      if (this.params) {
        for (let key in this.params) {
          if (key !== 'current' && key !== 'size') {
            this.queryInfo[key] = this.params[key]
          }
        }
      }
      if (!this.init) {
        //记录请求状态
        let state = {
          query: this.queryInfo,
          data: this.data
        }
        history.replaceState(state, document.title)
      }
      this.$emit('pagination', this.queryInfo, res => {
        if (res.code === '0') {
          let rows = res.data.records
          if (rows.length === 0 && this.queryInfo.current > 1) {
            //this.selectList(this.queryInfo.current - 1, this.queryInfo.size, this.queryParam, this.queryData)
            //如果没有查到，直接跳转到最后一页
            let pages = Number(res.data.pages)
            pages = pages < 1 ? 1 : pages
            this.selectList(pages, this.queryInfo.size, this.queryParam, this.queryData)
          } else {
            //数据总条数
            this.totals = Number(res.data.total)
            //返回数据记录
            return res.data.records
          }
        }
      }, this.data)
      //关闭初始状态
      this.init = false
    },
    handleSizeChange(val) {
      //此处兼容老版
      this.$emit('update:limit', val)
      //新版
      this.selectList(1, val)
    },
    handleCurrentChange(val) {
      //此处兼容老版
      this.$emit('update:page', val)
      //新版
      this.selectList(val)
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 10px 16px;
  border-top: 1px solid #b8b7b7;
}
</style>
